<template>
  <div>
    <Development></Development>
    <div id="maincontent" :class="[environment, $mq]">
      <Header></Header>

      <div id="main-content" :class="{ full_separator: full_separator }">
        <section
          id="overlay"
          v-show="overlay_is_visible"
          @click="closeOverlay()"
        ></section>

        <section id="loading" v-show="this.$store.state.is_loading"></section>

        <section id="container">
          <router-view />
        </section>

        <Footer></Footer>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/layout/Header";

import Footer from "@/components/layout/Footer";

import Development from "@/components/layout/Development";

import { Api } from "@/core/api.js";
const api = new Api();

export default {
  components: { Header, Footer, Development },
  data() {
    return {
      environment: process.env.VUE_APP_ENVIRONMENT,
    };
  },
  computed: {
    overlay_is_visible() {
      return this.$store.getters.overlay_is_visible;
    },

    full_separator() {
      return (
        this.$store.getters.getTopbarActionsVisible() &&
        this.$store.getters.getTopFiltersVisible()
      );
    },
  },
  methods: {
    closeOverlay() {
      this.$store.commit("setOverlayVisible", false);
    },
  },
  created() {
    this.$store.commit("setMenuVisible", false);
  },
};
</script>

<style lang="scss">
#maincontent {
  &.development {
    // position: relative;
    margin-top: $height-development;
  }

  #main-content {
    width: 100%;
    float: left;
    overflow: hidden;
    display: block;
    position: absolute;
    height: calc(100vh - 110px);

    &.full_separator {
      height: calc(100% - 160px);
    }

    #header {
    }

    #container {
      // padding: 20px 30px;
      height: 100%;
      overflow: auto;
    }

    #overlay {
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      background-color: #000;
      z-index: $z-overlay;
      // opacity: 0;
    }
  }
}

#maincontent.portrait {
  #main-content {
    height: calc(100vh - 170px);
  }
}
</style>
